// extracted by mini-css-extract-plugin
export default {"full-box-item__info":"full-box-item__info--392077","fullBoxItem__info":"full-box-item__info--392077"};